import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
	deserializeNotificationReads,
	ENVIRONMENT,
	HttpsParamsBuilderNew,
	MetaNew,
	NotificationReads,
	serializeNotificationReads,
} from '@agilox/common';
import { Observable, switchMap } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class NotificationReadsService {
	private readonly http = inject(HttpClient);
	private readonly environment = inject(ENVIRONMENT);

	getNotificationReads(
		number: number,
		size: number,
		sort: string,
		userId?: string,
		notificationIds?: string[]
	): Observable<{ notificationReads: NotificationReads[]; meta: MetaNew }> {
		const filter: any = {};
		notificationIds = Array.from(new Set(notificationIds));

		if (userId) {
			filter['user.id'] = userId;
		}
		if (notificationIds?.length) {
			filter['notification.id.in'] = notificationIds.filter((f: string) => !!f).join(',');
		}
		const params = HttpsParamsBuilderNew.buildParameters({
			pageNumber: number,
			pageSize: size,
			sort,
			filter,
		});
		return this.http
			.get<any>(this.environment.serverNew + '/user/v1/notification-reads', {
				params,
			})
			.pipe(switchMap((doc) => deserializeNotificationReads(doc)));
	}

	createNotificationRead(read: {
		userId: string;
		notificationId: string;
	}): Observable<NotificationReads> {
		return this.http.post<NotificationReads>(
			this.environment.serverNew + '/user/v1/notification-reads',
			serializeNotificationReads(read)
		);
	}

	deleteNotificationRead(id: string): Observable<NotificationReads> {
		return this.http.delete<NotificationReads>(
			this.environment.serverNew + `/user/v1/notification-reads/${id}`
		);
	}
}
